'use client'

import { useEffect } from 'react'

import type { ClientFlags } from '@mntn-dev/flags-types'
import { useSessionStorage } from '@mntn-dev/ui-utilities'
import { isMatch } from '@mntn-dev/utilities'

import { useQueryFlags } from './use-query-flags.ts'

/** Return a partial ClientFlags hydrated from session storage. */
export const useSessionFlags = (flags: ClientFlags) => {
  const queryFlags = useQueryFlags(flags)
  const [sessionFlags, setSessionFlags] = useSessionStorage<
    Partial<ClientFlags>
  >('flags', {})

  // Transfer any query flags to session storage flags
  useEffect(() => {
    if (
      Object.keys(queryFlags).length > 0 &&
      !isMatch(sessionFlags, queryFlags)
    ) {
      setSessionFlags((sessionFlags) => ({
        ...sessionFlags,
        ...queryFlags,
      }))
    }
  }, [setSessionFlags, queryFlags, sessionFlags])

  return sessionFlags
}
